import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'separarValores'
})
export class SepararValoresPipe implements PipeTransform {
  transform(value: string): string {
    if (!value) return value;
    return value.replace('_', '  -  ');
  }
}